import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import {formatDate} from '@angular/common';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import swal from 'sweetalert2';
import { CanserModel } from 'src/app/models/CanserModel';
import { PathologyModel } from 'src/app/models/PathologyModel';
import { CanserService } from 'src/app/services/CanserService';
import { DiganosisService } from 'src/app/services/DiganosisService';
import { DiganosisModel } from 'src/app/models/DiganosisModel';
import { CompanyService } from 'src/app/services/CompanyService';
import { CompanyModel } from 'src/app/models/CompanyModel';
import { DatabankModel } from 'src/app/models/DataBankModel';
import { DataBankService } from 'src/app/services/DataBankService';


@Component({
  selector: 'app-diganostic-entry',
  templateUrl: './diganostic-entry.component.html',
  styleUrls: ['./diganostic-entry.component.css']
})
export class DiganosticEntryComponent implements OnInit {
  patientcode = '' ;
  patientname = '';

  OriginalDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  digdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  digdiganosisdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  diglocation = '' ;
  cancerid = '' ;
  subcancerid ='';
  tissue = '' ;
  histology = '' ;
  grade = '' ;
  er = '' ;
  pdl1 = '' ;
  msi = '' ;
  egfr = '' ;
  alk = '' ;
  her2 = '' ;
  kras = '' ;
  braf = '' ;
  hrd = '' ;
  brca1 = '' ;
  brca2 = '' ;
  gscore = '' ;
  nfeature = '' ;
  pr = '' ;
  her2ihs = '' ;
  her2fish = '' ;
  ki67 = 0 ;
  hpv = '' ;
  digsite = '' ;
  digstage = '' ;
  digt = '' ;
  dign = '' ;
  digm = '' ;
  dignotes = '' ;
  userid = '';
  username = '';

tissuehed = 'Site of specimen' ;
histologyhed = 'Histology' ;
gradehed = 'Grade' ;
erhed = 'ER' ;
pdl1hed = 'PDL1' ;
msihed = 'MSI' ;
egfrhed = 'EGFR' ;
alkhed = 'ALK' ;
her2hed = 'HER2' ;
krashed = 'KRAS' ;
brafhed = 'BRAF' ;
hrdhed = 'HRD' ;
brca1hed = 'Germline BRCA1' ;
brca2hed = 'Germline BRCA2' ;
gscorehed = 'Gleason score' ;
nfeaturehed = 'Neuroendocrine' ;
Neuroendocrine = 'Neuroendocrine';
prhed = 'PR' ;
her2ihshed = 'HER2 IHC' ;
her2fishhed = 'HER2 FISH' ;
ki67hed = 'Ki67 %' ;
hpvhed = 'HPV status' ;
digsitehed = '' ;
digstagehed = 'Stage' ;
digthed = 'T' ;
dignhed = 'N' ;
digmhed = 'M' ;

  heddin_tissue = true ;
  heddin_tissuetext = true;
  heddin_histology = true ;
  heddin_grade = true ;
  heddin_er = true ;
  heddin_pdl1 = true ;
  heddin_msi = true ;
  heddin_egfr = true ;
  heddin_alk = true ;
  heddin_her2 = true ;
  heddin_kras = true ;
  heddin_braf = true ;
  heddin_hrd = true ;
  heddin_brca1 = true ;
  heddin_brca2 =    true ;
  heddin_gscore =   true ;
  heddin_nfeature = true ;

  heddin_pr =       true ;
  heddin_her2ihs = true;
  heddin_her2fish = true ;
  heddin_ki67 = true ;
  heddin_hpv = true ;
  heddin_digsite = true ;
  heddin_digstage = true ;
  heddin_digt = true ;
  heddin_dign = true ;
  heddin_digm = true ;
  heddin_dignotes = true ;
  heddin_Non12Cancer = true;


heddin_tissuehed = true;
heddin_histologyhed = true;
heddin_gradehed = true;
heddin_erhed = true;
heddin_pdl1hed = true;
heddin_msihed =  true;
heddin_egfrhed = true;
heddin_alkhed =  true;
heddin_her2hed = true;
heddin_krashed = true;
heddin_brafhed = true;
heddin_hrdhed =  true;
heddin_brca1hed= true;
heddin_brca2hed= true;
heddin_gscorehed = true;
heddin_nfeaturehed = true;
heddin_prhed = true;
heddin_her2ihshed = true;
heddin_her2fishhed = true;
heddin_ki67hed = true;
heddin_hpvhed = true;
heddin_digsitehed = true;
heddin_digstagehed = true;
heddin_digthed = true;
heddin_dignhed = true;
heddin_digmhed = true;


  hisologyvalue1 = 'Astrocytoma Grade 1';
  hisologyvalue2 = 'Astrocytoma grade 2';
  hisologyvalue3 = 'Astrocytoma grade 3';
  hisologyvalue4 = 'Glioblastoma';
  hisologyvalue5 = 'others';
  hisologyvalue6= '';
  hisologyvalue7 = '';
  ki67Perc = '%';

  ervalue1 = 'Positive';
  ervalue2 = 'Nagative';
  ersiz = 15;
  ersiz0 = 15;
  her2ihshedsize = 11;
  her2ihshedsize0 = 11.5;
  
  her2hedsize = 9.5;
  her2hedsize0 = 10;
  
  prvalue1 = 'Positive';
  prvalue2 = 'Nagative';
  prvalue3='';
  prvalue4='';
  prsiz = 15;
  prsiz0 = 15;

  tissuevalue1 = 'Biopsy';
  tissuevalue2 = 'Radical Surgery';
  tissuevalue3 = 'Metastatic lesion';
  tissuevalue4 = '';
  tissuevalue5 = '';
  tissuevalue6 = '';
  tissuesiz = 10;
  tissuesiz0 =0;
  histologysize = 8;
  histologysize0 = 0;

  prsize = 8.5;
  ki67size = 10;
  ki67size0 = 9.5;

  pdl1size = 8 ;
  pdl1size0 = 7.5 ;

  brcasize = 11;
  brcasize0= 10.5;
  msisize = 9;
  msisize0 = 8.5;
  egfrsize = 8;
  egfrsize0 = 9;
  alksiz0 = 9;
  alksiz = 8;
  
  krassize0 =9;
  krassize =8;
  
  brafsize0 =9;
  brafsize =8;

  hrdsize0 =9;
  hrdsize =8;

  gscoresize0 = 11;
  gscoresize = 10;
  
  hpvsize0 =  9;
  hpvsize = 8;

  Neuroendocrinesize0 = 11;
  Neuroendocrinesize =10;

  digstagesize0 =11;
  digstagesize =10.5;

  gradesize0 = 11;
  gradesize = 10.5;

  digtsize0 = 11;
  digtsize = 10.5;

  dignsize0 = 11;
  dignsize  = 10.5;

  digmsize0 = 11;
  digmsize = 10.5

  valuegrad1="Grade I";
  valuegrad2="Grade II";
  valuegrad3="Grade III";
  valuegrad4="NK";
  valuegrad5="";

  digtvalue1 = '0';
  digtvalue2 = '1';
  digtvalue3 = '2';
  digtvalue4 = '3';
  digtvalue5 = '4';
  digtvalue6 = 'tx';

  dignvalue1 = 'NX';
  dignvalue2 = '0';
  dignvalue3 = '1';
  dignvalue4 = '2';
  dignvalue5 = '3';

  digmvalue1 = '0';
  digmvalue2 = '1';
  digmvalue3 = 'Mx';

  her2ihsvalue1 = '0';
  her2ihsvalue2 = '1';
  her2ihsvalue3 = '2';
  her2ihsvalue4 = '3';

  msivalue1 = 'High';
  msivalue2 = 'Low';

  krasvalue1 ='Mutant'
  krasvalue2='Wild';

  brafvalue1='Mutant';
  brafvalue2='Wild';

  her2value1 = 'Positive';
  her2value2 = 'Negative';

  digtime  =formatDate(new Date(), 'HH:mm', 'en');
  pathology_M= '';
  paAge = 0;
  maxCharsPerLine =75;
  dignotestext = '';
  cancerList: CanserModel[] =[];

  cancerDetList : CanserModel[] =[];

  PathologyList:PathologyModel[]=[];
  companyList : CompanyModel[]=[];
  editorConfigNoToolbar = {
    editable: true,
    spellcheck: true,
    showToolbar: true,  // 🚫 This hides the toolbar
    height: '150px',
    width : '1400px',
    frameElement:true,
    minHeight: '0',
    placeholder: '',
    translate: 'yes',
    defaultParagraphSeparator: '',
    defaultFontName: '',

    toolbarHiddenButtons: [
    ['insertImage']  // 👈 Hide the Insert Image button
  ]
  };
  @Output() submitClicked = new EventEmitter<any>();
  constructor(  public canserService :CanserService,public storage: LocalStorageService,
                public diganosisService : DiganosisService,
                public diganosis : DiganosisModel,
                public companyService : CompanyService,
                public dataBankModel : DatabankModel,
                public databankservice :DataBankService,
                public dialogRef: MatDialogRef<DiganosticEntryComponent>,

              ) { }
  declocation ='1';

  ngOnInit(): void {
    this. retriveCancerLookup();
    this.retriveCompanyLookupTop();
    this.patientcode = this.storage.retrieve('stgPatientCode');
    this.patientname = this.storage.retrieve('stgPatientName');
    this.digdate =   formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');
    this.OriginalDate = formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');
    this.digtime  =formatDate(new Date(), 'hh:mm aa', 'en');
    this.declocation= this.storage.retrieve('stgLocation');



    if(this.storage.retrieve('stgcancerID') !='' || this.storage.retrieve('stgcancerID') !=null){this.cancerid =this.storage.retrieve('stgcancerID') ;};

    this.RetriveData();
    this.retriveCancerDetLookup();

  }
retriveCompanyLookupTop() {
    this.companyService.getLocationLookupTop('1').subscribe((data: CompanyModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.companyList[i] = data[i];
        }

      });
  }
  updatePlainText() {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = this.dignotes || '';
    this.dignotestext = tempElement.textContent || '';
  }
    limitLineLength() {
    const lines = this.dignotes.split("\n"); // Respect manual line breaks
    const formattedLines: string[] = [];

    for (let line of lines) {
      while (line.length > this.maxCharsPerLine) {
        let breakpoint = this.maxCharsPerLine;
        // Look for the last space before maxCharsPerLine to avoid breaking a word
        const lastSpace = line.lastIndexOf(" ", this.maxCharsPerLine);
        if (lastSpace > -1) {
          breakpoint = lastSpace;
        }
        // Push line up to the breakpoint
        formattedLines.push(line.substring(0, breakpoint).trim());
        // Trim and keep the rest of the line
         line = line.substring(breakpoint).trim();
      }
      formattedLines.push(line);
    }

    this.dignotes = formattedLines.join("\n");
  }
  RetriveData(){

        this.diganosisService.getDiganosis(this.patientcode, this.digdate).subscribe({
        next: (data: DiganosisModel) => {

          this.diglocation = data.diglocation;
          this.digdate =formatDate(data.digdate, 'yyyy-MM-dd', 'en');
          this.dignotes = data.dignotes;
          this.userid = data.userid;
          this.digtime = formatDate(data.digtime, 'hh:mm aa', 'en');
          this.digdiganosisdate =formatDate(data.digdiganosisdate, 'yyyy-MM-dd', 'en');

        this.cancerid=data.cancerid

        this.tissue=data.tissue
        this.histology=data.histology
        this.grade=data.grade
        this.er=data.er
        this.pdl1=data.pdl1
        this.msi=data.msi
        this.egfr=data.egfr
        this.alk=data.alk
        this.her2=data.her2
        this.kras=data.kras
        this.braf=data.braf
        this.hrd=data.hrd
        this.brca1=data.brca1
        this.brca2=data.brca2
        this.gscore=data.gscore
        this.nfeature=data.nfeature
        this.pr=data.pr
        this.her2ihs=data.her2ihs
        this.her2fish=data.her2fish
        this.ki67=data.ki67
        this.hpv=data.hpv
        this.digsite=data.digsite
        this.digstage=data.digstage
        this.digt=data.digt
        this.dign=data.dign
        this.digm=data.digm
        this.dignotes=data.dignotes

        this.tissuehed=data.tissuehed
        this.histologyhed=data.histologyhed
        this.gradehed=data.gradehed
        this.erhed=data.erhed
        this.pdl1hed=data.pdl1hed
        this.msihed=data.msihed
        this.egfrhed=data.egfrhed
        this.alkhed=data.alkhed
        this.her2hed=data.her2hed
        this.krashed=data.krashed
        this.brafhed=data.brafhed
        this.hrdhed=data.hrdhed
        this.brca1hed=data.brca1hed
        this.brca2hed=data.brca2hed
        this.gscorehed=data.gscorehed
        this.nfeaturehed=data.nfeaturehed
        this.prhed=data.prhed
        this.her2ihshed=data.her2ihshed
        this.her2fishhed=data.her2fishhed
        this.ki67hed=data.ki67hed
        this.hpvhed=data.hpvhed
        this.digsitehed=data.digsitehed
        this.digstagehed=data.digstagehed
        this.digthed=data.digthed
        this.dignhed=data.dignhed;
        this.canserService.getCancerDetLookupTop(this.cancerid,this.storage.retrieve('stgcompCode')).subscribe((data1: CanserModel[]) => {
         this.cancerDetList= data1;
          for (let i = 0; i < data1.length; i++) {this.cancerDetList[i].cancerID = data1[i].cancerID; this.cancerDetList[i].cancerName = data1[i].cancerName;  this.cancerDetList[i].notes = data1[i].notes;}
        this.subcancerid =data.canceridsub
        });

        ///---- **************** -----------------------
        if(this.cancerid =='C50'){
          this.msihed ='Laterality'
          this.msivalue1 = 'Left';
          this.msivalue2 = 'Right';
            }
        ///---------------------------------------------
        },
        error: (error) => {
          // Handle any actual errors here, if needed.  For example:
          console.error("Error fetching nurse assessment:", error);
          // You might also want to display an error message to the user.
        },
        complete: () => {
          // This block executes after a successful completion (even if data is null/undefined).
            if (!this.diglocation) {  // Check if visitlocation is undefined or null.  Could also check for an empty string "" if that's a possibility.
                this.diglocation = '1';
                this.digdate = formatDate(this.OriginalDate, 'yyyy-MM-dd', 'en');
                if(this.storage.retrieve('stgcancerID') !='' || this.storage.retrieve('stgcancerID') !=null){this.cancerid =this.storage.retrieve('stgcancerID'); this.retriveCancerDetLookup();};
              }
        }
      });
    }

  Save_Data(){

      this.digtime  =formatDate(new Date(), 'HH:mm', 'en');
      const str1 = formatDate(this.digdate, 'yyyy-MM-dd', 'en') + 'T' + this.digtime+':00.000Z';

      this.diganosis.patientcode= this.patientcode;
      this.diganosis.digdate= this.digdate;
      this.diganosis.digdiganosisdate= this.digdiganosisdate;

      this.diganosis.diglocation= this.diglocation;
      this.diganosis.cancerid= this.cancerid;
      this.diganosis.tissue= this.tissue.toString();
      this.diganosis.histology= this.histology;
      this.diganosis.grade= this.grade;
      this.diganosis.er= this.er;
      this.diganosis.pdl1= this.pdl1;
      this.diganosis.msi= this.msi;
      this.diganosis.egfr= this.egfr;
      this.diganosis.alk= this.alk;
      this.diganosis.her2= this.her2;
      this.diganosis.kras= this.kras;
      this.diganosis.braf= this.braf;
      this.diganosis.hrd= this.hrd;
      this.diganosis.brca1= this.brca1;
      this.diganosis.brca2= this.brca2;
      this.diganosis.gscore= this.gscore;
      this.diganosis.nfeature= this.nfeature;
      this.diganosis.pr= this.pr;
      this.diganosis.her2ihs= this.her2ihs;
      this.diganosis.her2fish= this.her2fish;
      this.diganosis.ki67= this.ki67;
      this.diganosis.hpv= this.hpv;
      this.diganosis.digsite= this.digsite;
      this.diganosis.digstage= this.digstage;
      this.diganosis.digt= this.digt;
      this.diganosis.dign= this.dign;
      this.diganosis.digm= this.digm;
      this.diganosis.dignotes= this.dignotes;
/////////-------------------------Headers ------------------------
      this.diganosis.username= this.username;
      this.diganosis.tissuehed= this.tissuehed;
      this.diganosis.histologyhed= this.histologyhed;
      this.diganosis.gradehed= this.gradehed;
      this.diganosis.erhed= this.erhed;
      this.diganosis.pdl1hed= this.pdl1hed;
      this.diganosis.msihed= this.msihed;
      this.diganosis.egfrhed= this.egfrhed;
      this.diganosis.alkhed= this.alkhed;
      this.diganosis.her2hed= this.her2hed;
      this.diganosis.krashed= this.krashed;
      this.diganosis.brafhed= this.brafhed;
      this.diganosis.hrdhed= this.hrdhed;
      this.diganosis.brca1hed= this.brca1hed;
      this.diganosis.brca2hed= this.brca2hed;
      this.diganosis.gscorehed= this.gscorehed;
      this.diganosis.nfeaturehed= this.nfeaturehed;
      this.diganosis.prhed= this.prhed;
      this.diganosis.her2ihshed= this.her2ihshed;
      this.diganosis.her2fishhed= this.her2fishhed;
      this.diganosis.ki67hed= this.ki67hed;
      this.diganosis.hpvhed= this.hpvhed;
      this.diganosis.digsitehed= this.digsitehed;
      this.diganosis.digstagehed= this.digstagehed;
      this.diganosis.digthed= this.digthed;
      this.diganosis.dignhed= this.dignhed;
      this.diganosis.digmhed= this.digmhed;
      this.diganosis.canceridsub= this.subcancerid;

////////---------------------------------------------------------------------
      this.diganosis.userid= this.storage.retrieve('stguserId');
      this.diganosis.username= this.storage.retrieve('stgusername');
      this.diganosis.digtime= str1;

      this.diganosisService.AddDiganosis(this.diganosis).subscribe(data => {
        this.submitDataBank();
        this.mesgSave();
        this.dialogRef.close();
      },
          error => { alert(error); }
        );
    }

    submitDataBank() {
      if (this.cancerid == null || this.cancerid == '') {
        return;
      }
      this.dataBankModel.dateEntry = formatDate(new Date(), 'yyyy-MM-dd', 'en');
      this.dataBankModel.birthDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');

      this.dataBankModel.patientCode = this.patientcode;
      this.dataBankModel.diagnosis = this.dignotes;
      this.dataBankModel.cancerID = this.cancerid;
      this.dataBankModel.pathology = '';

      this.dataBankModel.userID = 'sa';
      this.dataBankModel.compCode =  this.storage.retrieve('stgcompCode');
      this.dataBankModel.modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
      this.databankservice.UpdatePatient(this.dataBankModel).subscribe(data => {

      this.mesgSave();

      },

        error => { alert(error);
          console.log("Diom")}


      );

    }
  mesgSave() {
            swal({
            title: 'Your work has been saved',

            type: 'success',
            showConfirmButton: false,

            timer: 1500
            });
          }
  Exit_Data(){
        this.dialogRef.close();
   }
  retriveCancerLookup() {
    this.canserService.getCancerLookupTop().subscribe((data: CanserModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.cancerList[i] = data[i];
        }
        //this.cancerName[] = [];
      });
  }
  retriveCancerDetLookup() {

    this.canserService.getCancerDetLookupTop(this.cancerid,this.storage.retrieve('stgcompCode')).subscribe((data: CanserModel[]) => {
      this.cancerDetList= data;
      for (let i = 0; i < data.length; i++) {
          this.cancerDetList[i].cancerID = data[i].cancerID;
          this.cancerDetList[i].cancerName = data[i].cancerName;
          this.cancerDetList[i].notes = data[i].notes;
        }

      });
      this.Change_Cancer_Type();
  }


  Change_Cancer_Type(){

 this.new_Cancer();
//  console.log("subcancerid 1: ",this.subcancerid)
//  this.canserService.getCancerDetLookupTop(this.cancerid,this.storage.retrieve('stgcompCode')).subscribe((data: CanserModel[]) => {
//       this.cancerDetList= data;
//       for (let i = 0; i < data.length; i++) {
//           this.cancerDetList[i].cancerID = data[i].cancerID;
//           this.cancerDetList[i].cancerName = data[i].cancerName;
//           this.cancerDetList[i].notes = data[i].notes;
//         }

//       });
 if(this.subcancerid == null){this.subcancerid = ''}
//////////---------Acute Lymphoblastic Leukemia -----------
    if(this.cancerid == 'C83'){
      this.heddin_tissue = false;
      this.heddin_histology = true;
      this.heddin_tissuehed = false;
      this.heddin_tissuetext = true;
      this.tissuehed = 'Ph.Chromosome';
      this.tissuesiz = 10.5;
      this.tissuesiz0 = 11;

      this.heddin_grade = true;
      this.heddin_er = false;
      this.heddin_pdl1 = true;
      this.heddin_msi = true;
      this.heddin_Non12Cancer = false;

      this.heddin_nfeature = true;
      this.Neuroendocrine = 'POLE mutation';
 
      
      this.hisologyvalue1 = 'Endometrioid';
      this.hisologyvalue2 = 'Serous';
      this.hisologyvalue3 = 'Clear cell';
      this.hisologyvalue4 = 'Mixed adenocarcinoma';
      this.hisologyvalue5 = 'Others';
      this.hisologyvalue6 = '';
      this.hisologyvalue7 = '';
      this.histologysize = 10;
      this.histologysize0 = 9.5;

      this.ersiz = 15;
      this.ersiz0 = 14.5;
      
      this.erhed = 'JAK Status'

      this.ervalue1 = 'Mutant';
      this.ervalue2 = 'Non-Mutant';

      this.tissuevalue1 = 'Not Done';
      this.tissuevalue2 = 'Ph. Positive';
      this.tissuevalue3 = 'Ph. Nagative';
      this.tissuevalue4 = '';
      this.tissuevalue5 = '';
      this.tissuevalue6 = '';

      this.heddin_digthed = true;
      this.heddin_dignhed = true;
      this.heddin_digmhed = true;
      this.heddin_digstagehed = true;

      this.heddin_digt = true;
      this.heddin_dign = true;
      this.heddin_digm = true;

    }

//////////---------B-Cell Lymphomas -----------
    
if(this.cancerid == 'C82'){


      if(this.subcancerid == '' ){
      this.heddin_tissue = true;
      this.heddin_tissuetext = true;
      this.heddin_histology = true;
      this.heddin_grade = true;
      this.heddin_er = true;
      this.heddin_pdl1 = true;
      this.heddin_msi = true;
      this.heddin_Non12Cancer = true;
      this.heddin_nfeature = true;
      }
      if(this.subcancerid == '01' || this.subcancerid == '02'){
      this.digstagehed = 'Stage'
      this.heddin_digstage = false;

      this.gradehed = 'Grade';
      this.heddin_grade = false;
      this.heddin_gradehed = false;
      this.valuegrad1="Grade I";
      this.valuegrad2="Grade II";
      this.valuegrad3="Grade III";
      this.valuegrad4="NK";

      this.digthed = 'T';
      this.heddin_digt = false;

      this.dignhed = 'N';
      this.heddin_dign = false;

      this.digmhed = 'M';
      this.heddin_digm = false;

      this.heddin_tissue = true;
      this.heddin_tissuetext = true;
      this.heddin_histology = true;


      this.heddin_er = true;
      this.heddin_pdl1 = true;
      this.heddin_msi = true;
      this.heddin_Non12Cancer = true;
      this.heddin_nfeature = true;

      }
      
  if(this.subcancerid == '03'){
      this.digstagehed = 'Stage'
      this.heddin_digstage = false;

      this.gradehed = 'Grade';
      this.heddin_grade = false;
      this.heddin_gradehed = false;

      this.valuegrad1="Grade 1";
      this.valuegrad2="Grade 2";
      this.valuegrad3="Grade 3A";
      this.valuegrad4="Grade 3B";


      this.heddin_digthed = true;
      this.heddin_dignhed = true;
      this.heddin_digmhed = true;

      this.heddin_digt = true;
      this.heddin_dign = true;
      this.heddin_digm = true;

      this.heddin_tissue = true;
      this.heddin_tissuetext = true;
      this.heddin_histology = true;


      this.heddin_er = true;
      this.heddin_pdl1 = true;
      this.heddin_msi = true;
      this.heddin_Non12Cancer = true;
      this.heddin_nfeature = true;

      }
       if(this.subcancerid != '' && this.subcancerid != '01' && this.subcancerid != '02' && this.subcancerid != '03'){
      this.digstagehed = 'Stage'
      this.heddin_digstage = false;

      this.gradehed = 'Grade';
      this.heddin_grade = false;
      this.heddin_gradehed = false;

      this.valuegrad1="Grade I";
      this.valuegrad2="Grade II";
      this.valuegrad3="Grade III";
      this.valuegrad4="NK";

      this.heddin_digthed = true;
      this.heddin_dignhed = true;
      this.heddin_digmhed = true;

      this.heddin_digt = true;
      this.heddin_dign = true;
      this.heddin_digm = true;

      this.heddin_tissue = true;
      this.heddin_tissuetext = true;
      this.heddin_histology = true;


      this.heddin_er = true;
      this.heddin_pdl1 = true;
      this.heddin_msi = true;
      this.heddin_Non12Cancer = true;
      this.heddin_nfeature = true;

      }


    }
  //////////---------Chronic Lymphocytic Leukemia/Small -----------
    if(this.cancerid == 'C84'){
      this.digstagehed = 'Stage'
      this.heddin_digstage = false;

      this.gradehed = 'Grade';
      this.heddin_grade = false;
      this.heddin_gradehed = false;

      this.valuegrad1="Grade I";
      this.valuegrad2="Grade II";
      this.valuegrad3="Grade III";
      this.valuegrad4="NK";

      this.digthed = 'Rai system';
      this.heddin_digt = false;
      this.heddin_digthed = false;

      this.digtvalue1 = 'Low';
      this.digtvalue2 = 'Intermediate';
      this.digtvalue3 = 'high ';
      this.digtvalue4 = '';
      this.digtvalue5 = '';
      this.digtvalue6 = '';
         

      this.dignhed = 'Del(17P)/TP53';
      this.heddin_dign = false;
      this.heddin_dignhed = false;

      this.dignvalue1 = 'Present';
      this.dignvalue2 = 'Absent';
      this.dignvalue3 = 'Not tested ';
      this.dignvalue4 = '';
      this.dignvalue5 = '';

      this.digmhed = 'IGHV mutation';
      this.heddin_digm = false;
      this.heddin_digmhed = false;

      this.digmvalue1 = 'Mutant';
      this.digmvalue2 = 'Non-Mutant';
      this.digmvalue3 = 'Not tested ';



    }
     //////////---------Chronic Myeloid Leukemia  -----------
    if(this.cancerid == 'C86'){


      this.gradehed = 'Prognostic score';
      this.heddin_grade = false;
      this.heddin_gradehed = false;

      this.valuegrad1="Non";
      this.valuegrad2="Sokal score";
      this.valuegrad3="EUTOS score";
      this.valuegrad4="";

      this.digthed = 'Prognostic risk';
      this.heddin_digt = false;
      this.heddin_digthed = false;

      this.digtvalue1 = 'Low';
      this.digtvalue2 = 'Intermediate';
      this.digtvalue3 = 'high ';
      this.digtvalue4 = '';
      this.digtvalue5 = '';
      this.digtvalue6 = '';

      this.dignhed = 'Phase at 1st. pres.';
      this.heddin_dign = false;
      this.heddin_dignhed = false;

      this.dignvalue1 = 'Chronic';
      this.dignvalue2 = 'Accelerated';
      this.dignvalue3 = 'Blast crisis';
      this.dignvalue4 = '';
      this.dignvalue5 = '';

      this.digmhed = 'Ph.chromosome';
      this.heddin_digm = false;
      this.heddin_digmhed = false;

      this.digmvalue1 = 'Non';
      this.digmvalue2 = 'Ph Positive';
      this.digmvalue3 = 'Ph Negative';


    }
      //////////---------T-Cell Lymphomas  -----------
    if(this.cancerid == 'C118'){


      this.heddin_Non12Cancer = false;
      this.tissuehed = 'IPI';
      this.heddin_tissue = false;
      this.heddin_tissuehed = false;
      this.heddin_tissuetext = true;
      this.tissuesiz = 10.5;
      this.tissuesiz0 = 11;

      this.tissuevalue1="Low Risk";
      this.tissuevalue2="Low-Intermediate Risk";
      this.tissuevalue3="High-Intermediate Risk";
      this.tissuevalue4="High Risk";
      this.tissuevalue5="";
      this.tissuevalue6="";
     


      this.histologyhed = 'ALK';
      this.heddin_histology = false;
      this.heddin_histologyhed = false;
      this.histologysize = 10.5;
      this.histologysize0 = 11;

      this.hisologyvalue1 = 'Positive';
      this.hisologyvalue2 = 'Negative';
      this.hisologyvalue3 = 'Not Tested ';
      this.hisologyvalue4 = '';
      this.hisologyvalue5 = '';
      this.hisologyvalue6 = '';
      this.hisologyvalue7 = '';
      
    }
    //////////---------Acute Myeloid Leukemia -----------
    if(this.cancerid == 'C85'){
      this.heddin_tissue = false;
      this.heddin_histology = true;
      this.heddin_tissuehed = false;


      this.tissuehed = 'FAB';
      this.tissuevalue1 = 'M1';
      this.tissuevalue2 = 'M2';
      this.tissuevalue3 = 'M3';
      this.tissuevalue4 = 'M4';
      this.tissuevalue5 = 'M5';
      this.tissuevalue6 = 'M6';

      this.tissuesiz = 10.5;
      this.tissuesiz0 = 11;

      this.heddin_grade = true;
      this.heddin_er = false;
      this.heddin_pdl1 = true;
      this.heddin_msi = true;
      this.heddin_pr = false

      this.heddin_Non12Cancer = false;

      this.heddin_nfeature = true;
      this.Neuroendocrine = 'POLE mutation';
 
      this.ersiz = 10;
      this.ersiz0 = 10.5;

      this.erhed = 'FLT3'
      this.ervalue1 = 'Mutant';
      this.ervalue2 = 'Non-Mutant';

      this.heddin_prhed = false;
      this.prhed = 'CEBPA'
      this.prvalue1 = 'Mutant';
      this.prvalue2 = 'Non-Mutant';
      this.prvalue3='';
      this.prvalue4='';

    }
    //////////---------Primary Cutaneous Lymphomas -----------
    if(this.cancerid == 'C115'){


      this.digstagehed = 'Stage'
      this.heddin_digstage = false;

      // this.gradehed = 'Grade';
      // this.heddin_grade = false;
      // this.heddin_gradehed = false;

      this.digthed = 'T';
      this.heddin_digt = false;

      this.dignhed = 'N';
      this.heddin_dign = false;

      this.digmhed = 'M';
      this.heddin_digm = false;


    }
    //////////---------Plasma cell Malignancies -----------
    if(this.cancerid == 'C74'){

      if(this.subcancerid == '' ){
      this.heddin_tissue = true;
      this.heddin_histology = true;
      this.heddin_grade = true;
      this.heddin_er = true;
      this.heddin_pdl1 = true;
      this.heddin_msi = true;
      this.heddin_Non12Cancer = true;
      this.heddin_nfeature = true;
      this.heddin_gradehed = true;
      this.heddin_digt = true;
      this.heddin_dign = true;
      this.heddin_digm = true;
      }
      if(this.subcancerid != '' ){
      this.digstagehed = 'Stage'
      this.heddin_digstage = false;
      this.digstagesize0 = 11;
      this.digstagesize = 10.5;

      this.gradehed = 'Grade';
      this.heddin_grade = false;
      this.heddin_gradehed = false;

      this.digthed = 'Del(q17p)';
      this.heddin_digt = false;
      this.digtvalue1 = 'Present';
      this.digtvalue2 = 'Absent';
      this.digtvalue3 = 'Not tested';
      this.digtvalue4 = '';
      this.digtvalue5 = '';
      this.digtvalue6 = '';


      this.dignhed = 'Del(q13) ';
      this.heddin_dign = false;
      this.dignvalue1 = 'Present';
      this.dignvalue2 = 'Absent';
      this.dignvalue3 = 'Not tested';
      this.dignvalue4 = '';
      this.dignvalue5 = '';

      this.digmhed = 'Light chain type';
      this.heddin_digm = false;
      this.digmvalue1 = 'Kappa';
      this.digmvalue2 = 'Lambda';
      this.digmvalue3 = '';

      this.heddin_Non12Cancer = false;
      this.prhed = 'IG type';
      this.heddin_pr = false;
      this.heddin_prhed = false;
      this.prvalue1 = 'IgM';
      this.prvalue2 = 'IgG';
      this.prvalue3 = 'IgE';
      this.prvalue4 = 'IgD';
      this.prsiz0 = 11;
      this.prsize = 10.5;

       }

    }
    //////////---------Hairy Cell Leukemia -----------
    if(this.cancerid == 'C93'){


      this.heddin_Non12Cancer = false;
      this.tissuehed = 'BRAF V600E mutation';
      this.heddin_tissue = false;
      this.heddin_tissuetext = true;
      this.heddin_tissuehed = false;
      this.tissuevalue1 = 'Mutant';
      this.tissuevalue2 = 'Non-Mutant';
      this.tissuevalue3 = 'Not tested';
      this.tissuevalue4 = '';
      this.tissuevalue5 = '';
      this.tissuevalue6 = '';
      this.tissuesiz0 = 11;
      this.tissuesiz = 10.5;

      this.histologyhed = 'IGHV 4-34 mutation';
      this.heddin_histology = false;
      this.heddin_histologyhed = false;
      this.hisologyvalue1 = 'Mutant';
      this.hisologyvalue2 = 'Non-Mutant';
      this.hisologyvalue3 = 'Not tested';
      this.hisologyvalue4 = '';
      this.hisologyvalue5 = '';
      this.hisologyvalue6 = '';
      this.hisologyvalue7 = '';
      this.histologysize0 = 11;
      this.histologysize = 10.5;

    }
    //////////---------Waldenstrom Macroglobulinemia/Lymphoplasmacytic Lymphoma -----------
    if(this.cancerid == 'C94'){

      this.heddin_Non12Cancer = false;
      this.tissuehed = 'Risk scoring';
      this.heddin_tissue = false;
      this.heddin_tissuehed = false;
      this.tissuevalue1 = 'Low';
      this.tissuevalue2 = 'Low-Intermediate';
      this.tissuevalue3 = 'Intermediate';
      this.tissuevalue4 = 'High';
      this.tissuevalue5 = '';
      this.tissuevalue6 = '';
    
      this.tissuesiz0 =11;
      this.tissuesiz =10.5;
     
      this.histologyhed = 'Light chain';
      this.heddin_histology = false;
      this.heddin_histologyhed = false;
      this.hisologyvalue1 = 'Kappa';
      this.hisologyvalue2 = 'Lambda';
      this.hisologyvalue3 = 'Not tested';
      this.hisologyvalue4 = '';
      this.hisologyvalue5 = '';
      this.hisologyvalue6 = '';
      this.hisologyvalue7 = '';
      this.histologysize0 =11;
      this.histologysize =10.5;
     
      this.ki67hed = 'Score';
      this.heddin_ki67 = false;
      this.heddin_ki67hed = false;
      this.ki67size0 =11;
      this.ki67size =10.5;
      this.ki67Perc = '';

    }
     //////////-------------------- Hodgkin Lymphoma ------------------------------
    if(this.cancerid == 'C81'){
      this.heddin_Non12Cancer = false;
      this.heddin_tissue = true;
      this.heddin_tissuetext = false;
      this.heddin_tissuehed = false;
      this.tissue='0';
      this.tissuehed = '   Ann-Arbor staging';
      this.tissuesiz0 = 11;
      this.tissuesiz = 10.5;
      this.ki67Perc = '';
      this.ki67hed = 'Hasen-clever Prognostic scores';
      this.heddin_ki67 = false;
      this.heddin_ki67hed = false;
      this.ki67size0 = 11;
      this.ki67size = 10.5;
      this.ki67Perc = '';
      
      this.digstagehed = 'Stage'
      this.heddin_digstage = false;

      this.heddin_grade = false;
      this.heddin_gradehed = false;
      this.gradehed = 'Grade';
        this.valuegrad1="Grade I";
        this.valuegrad2="Grade II";
        this.valuegrad3="Grade III";
        this.valuegrad4="NK";
        this.valuegrad5="";

    }

    ///////-------------------Cancer Brest ------------------
    if(this.cancerid == 'C50'){
      this.heddin_tissue = false;
      this.heddin_tissuetext = true;
      this.heddin_tissuehed = false;
      this.tissuehed = 'Site of specimen'
      this.tissuesiz = 12;
      this.tissuesiz0 = 11;

      this.heddin_histology = false;
      this.heddin_histologyhed = false;
      this.histologyhed = 'Histopathology'
      this.histologysize = 10;
      this.histologysize0 = 9.5;

      this.ersiz = 8;
      this.ersiz0 = 8.5;
      
      this.prsiz = 7;
      this.prsiz0 = 8;
      
      this.her2ihshedsize = 9;
      this.her2ihshedsize0 = 9.5;
      
      this.her2hedsize = 9.5;
      this.her2hedsize0 = 8.5;
      
      this.ki67size = 7.5;
      this.ki67size0 = 7;
      
      this.pdl1size = 8 ;
      this.pdl1size0 = 7.5 ;

      this.brcasize = 9;
      this.brcasize0= 8.5;

      this.msisize = 9;
      this.msisize0 = 8.5;
      

      this.heddin_grade = false;
      this.heddin_gradehed = false;
      this.gradehed = 'Grade'
      this.valuegrad1="Grade I";
      this.valuegrad2="Grade II";
      this.valuegrad3="Grade III";
      this.valuegrad4="NK";

      this.digstagehed = 'Stage'
      this.heddin_digstage = false;
      this.digstagesize0 = 11;
      this.digstagesize = 10.5;

       this.digthed = 'T';
      this.heddin_digt = false;
      this.heddin_digthed = false;

      this.digtvalue1 = '0';
      this.digtvalue2 = '1';
      this.digtvalue3 = '2';
      this.digtvalue4 = '3';
      this.digtvalue5 = '4';
      this.digtvalue6 = 'Tx';

      this.dignhed = 'N';
      this.heddin_dign = false;
      this.heddin_dignhed = false;

      this.dignvalue1 = 'NX';
      this.dignvalue2 = '0';
      this.dignvalue3 = '1';
      this.dignvalue4 = '2';
      this.dignvalue5 = '3';
      
      

      this.digmhed = 'M';
      this.heddin_digm = false;
      this.heddin_digmhed = false;

      this.digmvalue1 = '0';
      this.digmvalue2 = '1';
      this.digmvalue3 = 'Mx';

      this.heddin_pdl1 = false;
      this.heddin_pdl1hed = false;
      this.pdl1hed = 'PDL1'

      this.heddin_brca1 = false;
      this.heddin_brca1hed = false;
      this.brca1hed ='germline BRCA1';

      this.heddin_brca2 = false;
      this.heddin_brca2hed = false;
      this.brca2hed ='germline BRCA2';

      this.heddin_pr = false;
      this.heddin_prhed = false;
      this.prhed ='PR';
      this.prvalue1 = 'Positive';
      this.prvalue2 = 'Negative';

      this.heddin_er = false;
      this.heddin_erhed = false;
      this.erhed ='ER';
      this.ersiz=9;
      this.ervalue1 = 'Positive';
      this.ervalue2 = 'Negative';

      this.heddin_her2ihs = false;
      this.heddin_her2ihshed = false;
      this.her2ihshed = 'HER2 IHC';
      this.her2ihshedsize = 9;
      this.her2ihsvalue1 = '0';
      this.her2ihsvalue2 = '1';
      this.her2ihsvalue3 = '2';
      this.her2ihsvalue4 = '3';

      this.heddin_her2fish = false;
      this.heddin_her2fishhed = false;
      this.her2fishhed ='HER2 FISH';

      this.heddin_ki67 = false;
      this.heddin_ki67hed = false;
      this.ki67hed ='ki67 %'
      this.ki67Perc = '%';
      
      this.heddin_Non12Cancer = false;
      this.histologyhed = 'Histopathology';
      this.hisologyvalue1 = 'IDC';
      this.hisologyvalue2 = 'ILC';
      this.hisologyvalue3 = 'Meduallry';
      this.hisologyvalue4 = 'Mucinous';
      this.hisologyvalue5 = '';
      this.hisologyvalue6 = '';
      this.hisologyvalue7 = '';

      this.tissuevalue1 = 'Biopsy';
      this.tissuevalue2 = 'Radical Surgery';
      this.tissuevalue4 = '';
      this.tissuevalue3 = '';

      this.heddin_msi = false;
      this.heddin_msihed = false;
      this.msihed ='Laterality'
      this.msivalue1 = 'Left';
      this.msivalue2 = 'Right';
      
      
    }
 //////////---------------- Cervical Cancer ----------------
    if(this.cancerid == 'C53'){
      this.heddin_Non12Cancer = false;
      this.histologyhed = 'Histopathology';
      this.heddin_histology = false;
      this.heddin_histologyhed = false;
      this.hisologyvalue1 = 'Squamous';
      this.hisologyvalue2 = 'Adenosquamous';
      this.hisologyvalue3 = 'others';
      this.hisologyvalue4 = '';
      this.hisologyvalue5 = '';
      this.hisologyvalue6 = '';
      this.hisologyvalue7 = '';
      this.histologysize0 =11;
      this.histologysize =10.5;


      this.digstagehed = 'Stage'
      this.heddin_digstage = false;

      this.gradehed = 'Grade';
      this.heddin_grade = false;
      this.heddin_gradehed = false;

      this.valuegrad1="Grade I";
      this.valuegrad2="Grade II";
      this.valuegrad3="Grade III";
      this.valuegrad4="NK";

      this.digthed = 'T';
      this.heddin_digt = false;
      this.heddin_digthed = false;

      this.digtvalue1 = '0';
      this.digtvalue2 = '1';
      this.digtvalue3 = '2';
      this.digtvalue4 = '3';
      this.digtvalue5 = '4';
      this.digtvalue6 = 'Tx';

      this.dignhed = 'N';
      this.heddin_dign = false;
      this.heddin_dignhed = false;

      this.dignvalue1 = '0';
      this.dignvalue2 = '1';
      this.dignvalue3 = 'Nx';

      this.digmhed = 'M';
      this.heddin_digm = false;
      this.heddin_digmhed = false;

      this.digmvalue1 = '0';
      this.digmvalue2 = '1';
      this.digmvalue3 = 'Mx';

    }
    ///////------------Colon Cancer /Rectal Cancer / esophageal and Esophaogastric--------------------
    if(this.cancerid == 'C18' || this.cancerid == 'C19' || this.cancerid == 'C15'){
      this.heddin_tissue = false;
      this.heddin_tissuetext = true;
      this.heddin_tissuehed = false;
      this.tissuehed = 'Site of specimen'
     this.tissuesiz = 12;
      this.tissuesiz0 = 12.5;

      this.tissuevalue1 = 'Biopsy';
      this.tissuevalue2 = 'Surgery';
      this.tissuevalue3 = 'Metastatic lesion';
      this.tissuevalue4 = '';

      this.heddin_Non12Cancer = false;
      this.histologyhed = 'Histopathology';
      this.heddin_histology = false;
      this.heddin_histologyhed = false;
      this.hisologyvalue1 = 'Adenocarcinoma';
      this.hisologyvalue2 = 'others';
      this.hisologyvalue3 = '';
      this.hisologyvalue4 = '';
      this.hisologyvalue5 = '';
      this.hisologyvalue6 = '';
      this.hisologyvalue7 = '';
      this.histologysize = 10;
      this.histologysize0 = 10.5;

      this.heddin_msi = false;
      this.heddin_msihed = false;
      this.msihed = 'MSI';
      this.msivalue1 = 'High';
      this.msivalue2 = 'Low';
      this.msisize = 9;
      this.msisize0 = 9;

      this.heddin_kras = false;
      this.heddin_krashed = false;
      this.krashed = 'KRAS';
      this.krasvalue1 ='Mutant'
      this.krasvalue2='Wild';

      this.heddin_braf = false;
      this.heddin_brafhed = false;
      this.brafhed = 'BRAF';
      this.brafvalue1='Mutant';
      this.brafvalue2='Wild';
      this.brafsize0 = 8.5;

     this.heddin_hrd = false;
     this.heddin_hrdhed = false;
     this.hrdhed = 'HER2';
     this.her2value1 = 'Positive';
     this.her2value2 = 'Negative';
     this.hrdsize0 = 8.5;

      this.digstagehed = 'Stage'
      this.heddin_digstage = false;

      this.heddin_grade = false;
      this.heddin_gradehed = false;
      this.gradehed = 'Grade';
       this.valuegrad1="Grade I";
      this.valuegrad2="Grade II";
      this.valuegrad3="Grade III";
      this.valuegrad4="NK";

      this.digthed = 'T';
      this.heddin_digt = false;
      this.heddin_digthed = false;

      this.digtvalue1 = '0';
      this.digtvalue2 = '1';
      this.digtvalue3 = '2';
      this.digtvalue4 = '3';
      this.digtvalue5 = '4';
      this.digtvalue6 = 'Tx';

      this.dignhed = 'N';
      this.heddin_dign = false;
      this.heddin_dignhed = false;

      this.dignvalue1 = '0';
      this.dignvalue2 = '1';
      this.dignvalue3 = 'Nx';

      this.digmhed = 'M';
      this.heddin_digm = false;
      this.heddin_digmhed = false;

      this.digmvalue1 = '0';
      this.digmvalue2 = '1';
      this.digmvalue3 = 'Mx';

    }
 /////------------------- Gastric Cancer ----------------
    if(this.cancerid == 'C16'){
      this.heddin_tissue = false;
      this.heddin_tissuetext = true;
      this.heddin_tissuehed = false;
      this.tissuehed = 'Site of specimen';
      this.tissuesiz = 10.7;
      this.tissuevalue1 = 'Biopsy';
      this.tissuevalue2 = 'Surgery';
      this.tissuevalue3 = 'Metastatic lesion';
      this.tissuevalue4 = '';
      this.tissuevalue5 = '';
      this.tissuevalue6 = '';
      this.tissuesiz0 =11;
      this.tissuesiz =10.5;


      this.heddin_histology = false;
      this.heddin_histologyhed = false;
      this.histologysize =10.3;
      this.histologysize0 =11;
      this.histologyhed = 'Histopathology';
      this.hisologyvalue1 = 'Adenocarcinoma';
      this.hisologyvalue2 = 'Signet ring';
      this.hisologyvalue3 = 'Squamous';
      this.hisologyvalue4 = 'Others';
      this.hisologyvalue5 = '';
      this.hisologyvalue6 = '';
      this.hisologyvalue7 = '';



      this.heddin_pdl1 = false;
      this.heddin_pdl1hed = false;
      this.pdl1hed = 'PDL1';
      this.pdl1size0 = 9;

      this.heddin_msi = false;
      this.heddin_msihed = false;
      this.msihed = 'MSI';

      this.heddin_her2 = false;
      this.heddin_her2hed = false;
      this.her2hed = 'HER2';

      this.heddin_Non12Cancer = false;

       this.digstagehed = 'Stage'
      this.heddin_digstage = false;


      this.heddin_grade = false;
      this.heddin_gradehed = false;
      this.gradehed = 'Grade';
       this.valuegrad1="Grade I";
      this.valuegrad2="Grade II";
      this.valuegrad3="Grade III";
      this.valuegrad4="NK";

      this.digthed = 'T';
      this.heddin_digt = false;
      this.heddin_digthed = false;

      this.digtvalue1 = '0';
      this.digtvalue2 = '1';
      this.digtvalue3 = '2';
      this.digtvalue4 = '3';
      this.digtvalue5 = '4';
      this.digtvalue6 = 'Tx';

      this.dignhed = 'N';
      this.heddin_dign = false;
      this.heddin_dignhed = false;

      this.dignvalue1 = '0';
      this.dignvalue2 = '1';
      this.dignvalue3 = 'Nx';

      this.digmhed = 'M';
      this.heddin_digm = false;
      this.heddin_digmhed = false;

      this.digmvalue1 = '0';
      this.digmvalue2 = '1';
      this.digmvalue3 = 'Mx';

    }
    //////////--------------- Uterine Neoplasms -------------
    if(this.cancerid == 'C54'){
      this.heddin_tissue = false;
      this.heddin_tissuetext = true;
      this.heddin_tissuehed = false;
      this.tissuehed = 'Site of specimen';
      this.tissuevalue1='Biopsy';
      this.tissuevalue2='Hysterectomy';
      this.tissuevalue3='Metastatic lesion';
      this.tissuevalue4='';
      this.tissuevalue5='';
      this.tissuevalue6='';
      this.tissuesiz0 =11;
      this.tissuesiz =10.5;
     

      this.heddin_histology = false;
      this.heddin_histologyhed = false;
      this.histologyhed = 'Histopathology';
      this.hisologyvalue1 = 'Endometrioid';
      this.hisologyvalue2 = 'serous';
      this.hisologyvalue3 = 'clear cell';
      this.hisologyvalue4 = 'mixed adenocarcinoma';
      this.hisologyvalue5 = 'Others';
      this.hisologyvalue6 = '';
      this.hisologyvalue7 = '';
 
      this.histologysize0 =11;
      this.histologysize =10.5;
     
      this.heddin_grade = false;
      this.heddin_Non12Cancer = false;


      this.heddin_grade = false;
      this.heddin_gradehed = false;
      this.gradehed = 'Grade';
       this.valuegrad1="Grade I";
      this.valuegrad2="Grade II";
      this.valuegrad3="Grade III";
      this.valuegrad4="NK";

      this.heddin_er = false;
      this.heddin_erhed = false;
      this.erhed = 'ER';
      this.ersiz0 =11;
      this.ersiz =10.5;
     

      this.heddin_pdl1 = false;
      this.heddin_pdl1hed = false;
      this.pdl1hed = 'PDL1';
      this.pdl1size0 =11;
      this.pdl1size =10.5;

      this.heddin_msi = false;
      this.heddin_msihed = false;
      this.msihed = 'MSI';

      this.msisize0 =11;
      this.msisize =10.5;

      this.heddin_Non12Cancer = false;
      this.heddin_Non12Cancer = false;
      this.digstagehed = 'Stage'
      this.heddin_digstage = false;

       this.gradehed = 'Grade'
      this.heddin_grade = false;
      this.heddin_gradehed = false;
      this.valuegrad1="Grade I";
      this.valuegrad2="Grade II";
      this.valuegrad3="Grade III";
      this.valuegrad4="NK";

      this.digthed = 'T';
      this.heddin_digt = false;
      this.heddin_digthed = false;

      this.digtvalue1 = '0';
      this.digtvalue2 = '1';
      this.digtvalue3 = '2';
      this.digtvalue4 = '3';
      this.digtvalue5 = '4';
      this.digtvalue6 = 'Tx';

      this.dignhed = 'N';
      this.heddin_dign = false;
      this.heddin_dignhed = false;

      this.dignvalue1 = '0';
      this.dignvalue2 = '1';
      this.dignvalue3 = 'Nx';

      this.digmhed = 'M';
      this.heddin_digm = false;
      this.heddin_digmhed = false;

      this.digmvalue1 = '0';
      this.digmvalue2 = '1';
      this.digmvalue3 = 'Mx';


    }
    //////------------Non-Small Cell Lung Cancer------------------
    if(this.cancerid == 'C34'){
      this.heddin_tissue = false;
      this.heddin_tissuetext = true;
      this.heddin_tissuehed = false;
      this.tissuehed = 'Site of specimen';
      this.tissuevalue1='Biopsy';
      this.tissuevalue2='Surgery';
      this.tissuevalue3='Metastatic lesion';
      this.tissuevalue4='';
      this.tissuevalue5='';
      this.tissuevalue6='';
      this.tissuesiz0=11;
      this.tissuesiz=10.5;

      this.heddin_histology = false;
      this.heddin_histologyhed = false;
      this.histologyhed = 'Histopathology';
      this.hisologyvalue1 = 'large cell';
      this.hisologyvalue2 = 'adenocarcinoma';
      this.hisologyvalue3 = 'squamous';
      this.hisologyvalue4 = 'Others';
      this.hisologyvalue5 = '';
      this.hisologyvalue6 = '';
      this.hisologyvalue7 = '';
      this.histologysize=10.5;
      this.histologysize0 = 10.8;

      this.heddin_Non12Cancer = false;
      this.heddin_pdl1 = false;
      this.heddin_pdl1hed = false;
      this.pdl1hed = 'PDL1';
      this.pdl1size=8.2;
      this.pdl1size0=8.5;

      this.heddin_egfr = false;
      this.heddin_egfrhed = false;
      this.egfrhed = 'EGFR';

      this.heddin_alk = false;
      this.heddin_alkhed = false;
      this.alkhed = 'ALK';

      this.heddin_Non12Cancer = false;
      this.digstagehed = 'Stage'
      this.heddin_digstage = false;

       this.heddin_grade = false;
      this.heddin_gradehed = false;
      this.gradehed = 'Grade'
      this.valuegrad1="Grade I";
      this.valuegrad2="Grade II";
      this.valuegrad3="Grade III";
      this.valuegrad4="NK";

      this.digthed = 'T';
      this.heddin_digt = false;
      this.heddin_digthed = false;

      this.digtvalue1 = '0';
      this.digtvalue2 = '1';
      this.digtvalue3 = '2';
      this.digtvalue4 = '3';
      this.digtvalue5 = '4';
      this.digtvalue6 = 'Tx';

      this.dignhed = 'N';
      this.heddin_dign = false;
      this.heddin_dignhed = false;

      this.dignvalue1 = '0';
      this.dignvalue2 = '1';
      this.dignvalue3 = 'Nx';

      this.digmhed = 'M';
      this.heddin_digm = false;
      this.heddin_digmhed = false;

      this.digmvalue1 = '0';
      this.digmvalue2 = '1';
      this.digmvalue3 = 'Mx';

    }
   //////--------------------Ovarian Cancer/Fallopian Tube Cancer/Primary Peritoneal Cancer-
    if(this.cancerid == 'C56'){
      this.heddin_tissue = false;
      this.heddin_tissuetext = true;
      this.heddin_tissuehed = false;
      this.tissuehed = 'Site of specimen';
      this.tissuevalue1='Biopsy';
      this.tissuevalue2='Surgery';
      this.tissuevalue3='Metastatic lesion';
      this.tissuevalue4='';
      this.tissuevalue5='';
      this.tissuevalue6='';
      this.tissuesiz0 =11;
      this.tissuesiz =10.5;

      this.heddin_histology = false;
      this.heddin_histologyhed = false;
      this.histologyhed = 'Histopathology';
      this.hisologyvalue1 = 'Serous';
      this.hisologyvalue2 = 'Mucinous';
      this.hisologyvalue3 = 'Endometriosis';
      this.hisologyvalue4 = 'Clear cell';
      this.hisologyvalue5 = 'germ cell tumors';
      this.hisologyvalue6 = 'sex-cord stromal tumor';
      this.hisologyvalue7 = 'Others';
      this.histologysize0 =11;
      this.histologysize =10.5;

      this.heddin_hrd = false;
      this.heddin_hrdhed = false;
      this.hrdhed = 'HRD';
      this.hrdsize0 =11;
      this.hrdsize =10.5;

      this.heddin_brca1 = false;
      this.heddin_brca2 = false;
      this.brca1hed ='germline BRCA1';
      this.heddin_Non12Cancer = false;
        this.brca2hed ='germline BRCA2';
      this.brcasize0 =11;
      this.brcasize =10.5;

      this.heddin_Non12Cancer = false;
      this.digstagehed = 'Stage'
      this.heddin_digstage = false;
      
      this.gradehed = 'Grade'
      this.heddin_grade = false;
      this.heddin_gradehed = false;
       this.valuegrad1="Grade I";
      this.valuegrad2="Grade II";
      this.valuegrad3="Grade III";
      this.valuegrad4="NK";
      
      this.digthed = 'T';
      this.heddin_digt = false;
      this.heddin_digthed = false;

      this.digtvalue1 = '0';
      this.digtvalue2 = '1';
      this.digtvalue3 = '2';
      this.digtvalue4 = '3';
      this.digtvalue5 = '4';
      this.digtvalue6 = 'Tx';

      this.dignhed = 'N';
      this.heddin_dign = false;
      this.heddin_dignhed = false;

      this.dignvalue1 = '0';
      this.dignvalue2 = '1';
      this.dignvalue3 = 'Nx';

      this.digmhed = 'M';
      this.heddin_digm = false;
      this.heddin_digmhed = false;

      this.digmvalue1 = '0';
      this.digmvalue2 = '1';
      this.digmvalue3 = 'Mx';
    }
    //////------------Kidney Cancer-----------------
    if(this.cancerid == 'C64'){
       this.heddin_tissue = false;
       this.heddin_tissuetext = true;
      this.heddin_tissuehed = false;
      this.tissuehed = 'Site of specimen';
      this.tissuevalue1='Biopsy';
      this.tissuevalue2='Nephrectomy';
      this.tissuevalue3='Metastatic lesion';
      this.tissuevalue4='';
      this.tissuevalue5='';
      this.tissuevalue6='';
      this.tissuesiz0 =11;
      this.tissuesiz =10.5;

      this.heddin_histology = false;
      this.heddin_histologyhed = false;
      this.histologyhed = 'Histopathology';
      this.hisologyvalue1 = 'clear cell';
      this.hisologyvalue2 = 'non-clear cell';
      this.hisologyvalue3 = 'Others';
      this.hisologyvalue4 = '';
      this.hisologyvalue5 = '';
      this.hisologyvalue6 = '';
      this.hisologyvalue7 = '';

      this.histologysize =10.8;
      this.histologysize0 =11;

      this.heddin_Non12Cancer = false;
      this.heddin_pdl1 = false;
      this.heddin_pdl1hed = false;
      this.pdl1hed = 'PDL1';

      this.digstagehed = 'Stage'
      this.heddin_digstage = false;

      this.heddin_grade = false;
      this.heddin_gradehed = false;
      this.gradehed = 'Grade'

        this.digthed = 'T';
      this.heddin_digt = false;
      this.heddin_digthed = false;

      this.digtvalue1 = '0';
      this.digtvalue2 = '1';
      this.digtvalue3 = '2';
      this.digtvalue4 = '3';
      this.digtvalue5 = '4';
      this.digtvalue6 = 'Tx';

      this.dignhed = 'N';
      this.heddin_dign = false;
      this.heddin_dignhed = false;

      this.dignvalue1 = '0';
      this.dignvalue2 = '1';
      this.dignvalue3 = 'Nx';

      this.digmhed = 'M';
      this.heddin_digm = false;
      this.heddin_digmhed = false;

      this.digmvalue1 = '0';
      this.digmvalue2 = '1';
      this.digmvalue3 = 'Mx';

    }
   ////////--------------Prostate Cancer ----------------------------
    if(this.cancerid == 'C61'){
      this.heddin_tissue = false;
      this.heddin_tissuetext = true;
      this.heddin_tissuehed = false;
      this.tissuehed = 'Site of specimen';
      this.tissuevalue1='Biopsy';
      this.tissuevalue2='Prostatectomy';
      this.tissuevalue3='Metastatic lesion';
      this.tissuevalue4='';
      this.tissuevalue5='';
      this.tissuevalue6='';
      this.tissuesiz0 =11;
      this.tissuesiz =10.5;

      this.heddin_msi = false;
      this.heddin_msihed = false;
      this.msihed = 'MSI';
      this.msisize0 =11;
      this.msisize =10.5;


      this.heddin_Non12Cancer = false;

      this.heddin_gscore = false;
      this.heddin_gscorehed = false;
      this.gscorehed = 'Gleason score';
      this.gscoresize0 = 11;
      this.gscoresize = 10.5

      

      this.heddin_nfeature = false;
      this.heddin_nfeaturehed = false;
      this.Neuroendocrine = 'Neuroendocrine';
      this.Neuroendocrinesize0 = 11;
      this.Neuroendocrinesize = 10.5
      
      this.heddin_Non12Cancer = false;
      this.digstagehed = 'Stage'
      this.heddin_digstage = false;

      this.gradehed = 'Grade'
      this.heddin_grade = false;
      this.heddin_gradehed = false;
      this.valuegrad1="Grade I";
      this.valuegrad2="Grade II";
      this.valuegrad3="Grade III";
      this.valuegrad4="Grade IV";
      this.valuegrad5="Grade IIV";

      this.digthed = 'T';
      this.heddin_digt = false;
      this.heddin_digthed = false;

      this.digtvalue1 = '0';
      this.digtvalue2 = '1';
      this.digtvalue3 = '2';
      this.digtvalue4 = '3';
      this.digtvalue5 = '4';
      this.digtvalue6 = 'Tx';

      this.dignhed = 'N';
      this.heddin_dign = false;
      this.heddin_dignhed = false;

      this.dignvalue1 = '0';
      this.dignvalue2 = '1';
      this.dignvalue3 = 'Nx';

      this.digmhed = 'M';
      this.heddin_digm = false;
      this.heddin_digmhed = false;

      this.digmvalue1 = '0';
      this.digmvalue2 = '1';
      this.digmvalue3 = 'Mx';

    }
    /////---------------------Bladder Cancer---------------
    if(this.cancerid == 'C67'){
      this.heddin_tissue = false;
      this.heddin_tissuetext = true;
      this.heddin_tissuehed = false;
      this.tissuehed = 'Site of specimen';
      this.tissuevalue1='Biopsy';
      this.tissuevalue2='Radical cystectomy ';
      this.tissuevalue3='Metastatic lesion';
      this.tissuevalue4='';
      this.tissuevalue5='';
      this.tissuevalue6='';
      this.tissuesiz0 =11;
      this.tissuesiz =10.5;


      this.heddin_histology = false;
      this.heddin_histologyhed = false;
      this.histologyhed = 'Histopathology';
      this.hisologyvalue1 = 'Transitional cell carcinoma';
      this.hisologyvalue2 = 'Squamous cell carcinoma';
      this.hisologyvalue3 = 'Others';
      this.hisologyvalue4 = '';
      this.hisologyvalue5 = '';
      this.hisologyvalue6 = '';
      this.hisologyvalue7 = '';
      this.histologysize0 = 11;
      this.histologysize0 = 10.5;

      this.heddin_pdl1 = false;
      this.heddin_pdl1hed = false;
      this.pdl1hed = 'PDL1';
      this.pdl1size0=8;
      this.heddin_Non12Cancer = false;
            this.digstagehed = 'Stage'
      this.heddin_digstage = false;

      this.heddin_grade = false;
      this.heddin_gradehed = false;
      this.gradehed = 'Grade';
       this.valuegrad1="Grade I";
      this.valuegrad2="Grade II";
      this.valuegrad3="Grade III";
      this.valuegrad4="NK";

        this.digthed = 'T';
      this.heddin_digt = false;
      this.heddin_digthed = false;

      this.digtvalue1 = '0';
      this.digtvalue2 = '1';
      this.digtvalue3 = '2';
      this.digtvalue4 = '3';
      this.digtvalue5 = '4';
      this.digtvalue6 = 'Tx';

      this.dignhed = 'N';
      this.heddin_dign = false;
      this.heddin_dignhed = false;

      this.dignvalue1 = '0';
      this.dignvalue2 = '1';
      this.dignvalue3 = 'Nx';

      this.digmhed = 'M';
      this.heddin_digm = false;
      this.heddin_digmhed = false;

      this.digmvalue1 = '0';
      this.digmvalue2 = '1';
      this.digmvalue3 = 'Mx';

    }
   //////-------------------Central Nervous System Cancer/Spinal cord & Cranial nerves tumours------------
    if(this.cancerid == 'C71' ){
      this.heddin_tissue = false;
      this.heddin_tissuetext = true;
      this.heddin_tissuehed = false;
      this.tissuehed = 'Site of specimen';
      this.tissuevalue1 = 'Biopsy';
      this.tissuevalue2 = 'Radical Surgery';
      this.tissuevalue3='';
      this.tissuevalue4='';
      this.tissuevalue5='';
      this.tissuevalue6='';
      this.tissuesiz0 =11;
      this.tissuesiz =10.5;


      this.heddin_histology = false;
      this.heddin_histologyhed = false;
      this.histologyhed = 'Histopathology';
      this.hisologyvalue1 = 'Astrocytoma';
      this.hisologyvalue2 = 'Glioblastoma';
      this.hisologyvalue3 = 'Others';
      this.hisologyvalue4 = '';
      this.hisologyvalue5 = '';
      this.hisologyvalue6= '';
      this.hisologyvalue7 = '';
      this.histologysize= 12;
      this.histologysize0= 12.5;

      this.heddin_Non12Cancer = false;
       this.digstagehed = 'Stage'
      this.heddin_digstage = false;

        this.gradehed = 'Grade'
      this.heddin_grade = false;
      this.heddin_gradehed = false;
       this.valuegrad1="Grade I";
      this.valuegrad2="Grade II";
      this.valuegrad3="Grade III";
      this.valuegrad4="NK";

        this.digthed = 'T';
      this.heddin_digt = false;
      this.heddin_digthed = false;

      this.digtvalue1 = '0';
      this.digtvalue2 = '1';
      this.digtvalue3 = '2';
      this.digtvalue4 = '3';
      this.digtvalue5 = '4';
      this.digtvalue6 = 'Tx';

      this.dignhed = 'N';
      this.heddin_dign = false;
      this.heddin_dignhed = false;

      this.dignvalue1 = '0';
      this.dignvalue2 = '1';
      this.dignvalue3 = 'Nx';

      this.digmhed = 'M';
      this.heddin_digm = false;
      this.heddin_digmhed = false;

      this.digmvalue1 = '0';
      this.digmvalue2 = '1';
      this.digmvalue3 = 'Mx';

    }
    //////-----------------------Thyroid Carcinoma----------
    if(this.cancerid == 'C73'){
      this.heddin_tissue = false;
      this.heddin_tissuetext = true;
      this.heddin_tissuehed = false;
      this.tissuehed = 'Site of specimen';
      this.tissuevalue1 = 'FNA';
      this.tissuevalue2 = 'Subtotal thyroidectomy';
      this.tissuevalue3 = 'Total thyroidectomy';
      this.tissuevalue4 = 'Metastatic lesion';
      this.tissuevalue5='';
      this.tissuevalue6='';
       this.tissuesiz0 =11;
      this.tissuesiz =10.5;

      this.heddin_histology = false;
      this.heddin_histologyhed = false;
      this.histologyhed = 'Histopathology';
      this.hisologyvalue1 = 'Follicular';
      this.hisologyvalue2 = 'Papillary';
      this.hisologyvalue3 = 'Medullary';
      this.hisologyvalue4 = 'Anaplastic';
      this.hisologyvalue5 = 'Others';
      this.hisologyvalue6 = '';
      this.hisologyvalue7 = '';
      this.histologysize0 =11;
      this.histologysize =10.5;
      this.heddin_Non12Cancer = false;
       
      this.digstagehed = 'Stage'
      this.heddin_digstage = false;

       this.gradehed = 'Grade'
      this.heddin_grade = false;
      this.heddin_gradehed = false;
 this.valuegrad1="Grade I";
      this.valuegrad2="Grade II";
      this.valuegrad3="Grade III";
      this.valuegrad4="NK";

      this.digthed = 'T';
      this.heddin_digt = false;
      this.heddin_digthed = false;

      this.digtvalue1 = '0';
      this.digtvalue2 = '1';
      this.digtvalue3 = '2';
      this.digtvalue4 = '3';
      this.digtvalue5 = '4';
      this.digtvalue6 = 'Tx';

      this.dignhed = 'N';
      this.heddin_dign = false;
      this.heddin_dignhed = false;

      this.dignvalue1 = '0';
      this.dignvalue2 = '1';
      this.dignvalue3 = 'Nx';

      this.digmhed = 'M';
      this.heddin_digm = false;
      this.heddin_digmhed = false;

      this.digmvalue1 = '0';
      this.digmvalue2 = '1';
      this.digmvalue3 = 'Mx';


    }
  ////--------------------Head and Neck Cancers-----------------------
    if(this.cancerid == 'C110'){
      this.heddin_tissue = false;
      this.heddin_tissuetext = true;
      this.heddin_tissuehed = false;
      this.tissuehed = 'Site of specimen';
      this.tissuevalue1 = 'primary site or lymph node';
      this.tissuevalue2 = 'biopsy';
      this.tissuevalue3 = 'radical surgery';
      this.tissuevalue4 = 'metastatic lesion';
      this.tissuevalue5='';
      this.tissuevalue6='';
      this.tissuesiz0 =11;
      this.tissuesiz =10.5;

      this.heddin_histology = false;
      this.heddin_histologyhed = false;
      this.histologyhed = 'Histopathology';
      this.hisologyvalue1 = 'Squamous cell carcinoma';
      this.hisologyvalue2 = 'Others';
      this.hisologyvalue3 = '';
      this.hisologyvalue4 = '';
      this.hisologyvalue5 = '';
      this.hisologyvalue6 = '';
      this.hisologyvalue7 = '';
      this.histologysize0 =11;
      this.histologysize =10.5;
      
      this.digstagehed = 'Stage'
      this.heddin_digstage = false;

      this.heddin_grade = false;
      this.heddin_gradehed = false;
      this.gradehed = 'Grade';
       this.valuegrad1="Grade I";
      this.valuegrad2="Grade II";
      this.valuegrad3="Grade III";
      this.valuegrad4="NK";

        this.digthed = 'T';
      this.heddin_digt = false;
      this.heddin_digthed = false;

      this.digtvalue1 = '0';
      this.digtvalue2 = '1';
      this.digtvalue3 = '2';
      this.digtvalue4 = '3';
      this.digtvalue5 = '4';
      this.digtvalue6 = 'Tx';

      this.dignhed = 'N';
      this.heddin_dign = false;
      this.heddin_dignhed = false;

      this.dignvalue1 = '0';
      this.dignvalue2 = '1';
      this.dignvalue3 = 'Nx';

      this.digmhed = 'M';
      this.heddin_digm = false;
      this.heddin_digmhed = false;

      this.digmvalue1 = '0';
      this.digmvalue2 = '1';
      this.digmvalue3 = 'Mx';

      this.heddin_pdl1 = false;
      this.heddin_pdl1hed = false;
      this.pdl1hed = 'PDL1';

      this.heddin_hpv = false;
      this.heddin_hpvhed = false;
      this.hpvhed = 'HPV';

      this.heddin_Non12Cancer = false;

    }
  
  ////-------------------- Pancreatic Adenocarcinoma -----------------------
    if(this.cancerid == 'C25'){
      this.heddin_tissue = false;
      this.heddin_tissuetext = true;
      this.heddin_tissuehed = false;
      this.tissuehed = 'Germline BRCA1';
      this.tissuevalue1 = 'Positive';
      this.tissuevalue2 = 'Negative';
      this.tissuevalue3 = '';
      this.tissuevalue4 = '';
      this.tissuevalue5='';
      this.tissuevalue6='';
      this.tissuesiz0 =11;
      this.tissuesiz =10.5;

      this.heddin_histology = false;
      this.heddin_histologyhed = false;
      this.histologyhed = 'Germline BRCA2';
      this.hisologyvalue1 = 'Positive';
      this.hisologyvalue2 = 'Negative';
      this.hisologyvalue3 = '';
      this.hisologyvalue4 = '';
      this.hisologyvalue5 = '';
      this.hisologyvalue6 = '';
      this.hisologyvalue7 = '';
      this.histologysize0 =11;
      this.histologysize =10.5;
      
      this.digstagehed = 'Stage'
      this.heddin_digstage = false;

       this.heddin_grade = false;
      this.heddin_gradehed = false;
      this.gradehed = 'Grade';
       this.valuegrad1="Grade I";
      this.valuegrad2="Grade II";
      this.valuegrad3="Grade III";
      this.valuegrad4="NK";

       this.digthed = 'T';
      this.heddin_digt = false;
      this.heddin_digthed = false;

      this.digtvalue1 = '0';
      this.digtvalue2 = '1';
      this.digtvalue3 = '2';
      this.digtvalue4 = '3';
      this.digtvalue5 = '4';
      this.digtvalue6 = 'Tx';

      this.dignhed = 'N';
      this.heddin_dign = false;
      this.heddin_dignhed = false;

      this.dignvalue1 = '0';
      this.dignvalue2 = '1';
      this.dignvalue3 = 'Nx';

      this.digmhed = 'M';
      this.heddin_digm = false;
      this.heddin_digmhed = false;

      this.digmvalue1 = '0';
      this.digmvalue2 = '1';
      this.digmvalue3 = 'Mx';


      this.heddin_Non12Cancer = false;

    }

 ////-------------------- Gestational trophoblastic neoplasia -----------------------
    if(this.cancerid == 'C52'){
      
      this.digstagehed = 'Stage'
      this.heddin_digstage = false;

      // this.heddin_grade = false;
      // this.heddin_gradehed = false;
      // this.gradehed = 'Grade'

      //  this.digthed = 'T';
      // this.heddin_digt = false;
      // this.heddin_digthed = false;

      // this.digtvalue1 = '0';
      // this.digtvalue2 = '1';
      // this.digtvalue3 = '2';
      // this.digtvalue4 = '3';
      // this.digtvalue5 = '4';
      // this.digtvalue6 = 'Tx';

      // this.dignhed = 'N';
      // this.heddin_dign = false;
      // this.heddin_dignhed = false;

      // this.dignvalue1 = '0';
      // this.dignvalue2 = '1';
      // this.dignvalue3 = 'Nx';

      // this.digmhed = 'M';
      // this.heddin_digm = false;
      // this.heddin_digmhed = false;

      // this.digmvalue1 = '0';
      // this.digmvalue2 = '1';
      // this.digmvalue3 = 'Mx';


      this.heddin_Non12Cancer = false;

    }
    if(this.cancerid == 'C111' || this.cancerid == 'C41'){ 

      this.heddin_Non12Cancer = false;
      this.digstagehed = 'Stage';
      this.heddin_digstage = false;

      this.gradehed = 'Grade';
      this.heddin_grade = false;
      this.heddin_gradehed = false;
       this.valuegrad1="Grade I";
      this.valuegrad2="Grade II";
      this.valuegrad3="Grade III";
      this.valuegrad4="NK";

      this.digthed = 'T';
      this.heddin_digt = false;
      this.heddin_digthed = false;

      this.digtvalue1 = '0';
      this.digtvalue2 = '1';
      this.digtvalue3 = '2';
      this.digtvalue4 = '3';
      this.digtvalue5 = '4';
      this.digtvalue6 = 'Tx';

      this.dignhed = 'N';
      this.heddin_dign = false;
      this.heddin_dignhed = false;

      this.dignvalue1 = '0';
      this.dignvalue2 = '1';
      this.dignvalue3 = 'Nx';

      this.digmhed = 'M';
      this.heddin_digm = false;
      this.heddin_digmhed = false;

      this.digmvalue1 = '0';
      this.digmvalue2 = '1';
      this.digmvalue3 = 'Mx';

      this.pdl1hed ='PDL1'
      this.heddin_pdl1=false;
      this.heddin_pdl1hed=false;
      this.pdl1size = 10.5;
      this.pdl1size0 = 11;
      
      
      
    }
    /////--------------------- Bone Cancer/Anal carcinoma /Basal cell cancer/Biliary tract cancer /Dermatofibrosarcoma /Gastrointestinal stromal tumors(add TNM and stage)---------------
    /////--------------------- Hepatobiliary cancers /Hepatocellular carcinoma /Melonoma /Mesothelioma peritoneal/Neuroblstoma/Small bowel adenocarcinoma/Penile cancer /Small bowel adenocarcinoma/Soft tissue sarcoma/Squamous cell skin cancer /Testicular cancer  
  
    if(this.cancerid == 'C40' || this.cancerid == 'C21' || this.cancerid == 'C104' || this.cancerid == 'C24' || this.cancerid == 'C108' || this.cancerid == 'C47' || this.cancerid == 'C97' || this.cancerid == 'C22' || this.cancerid == 'C44' || this.cancerid == 'C109' ||  this.cancerid == 'C114' || this.cancerid == 'C28' || this.cancerid == 'C33' || this.cancerid == 'C69' || this.cancerid == 'C17' || this.cancerid == 'C45' || this.cancerid == 'C105' || this.cancerid == 'C62' || this.cancerid == 'C37' || this.cancerid == 'C59'  || this.cancerid == 'C46' ){
      
      this.heddin_Non12Cancer = false;
      this.digstagehed = 'Stage'
      this.heddin_digstage = false;

      this.gradehed = 'Grade'
      this.heddin_grade = false;
      this.heddin_gradehed = false;
       this.valuegrad1="Grade I";
      this.valuegrad2="Grade II";
      this.valuegrad3="Grade III";
      this.valuegrad4="NK";

      this.digthed = 'T';
      this.heddin_digt = false;
      this.heddin_digthed = false;

      this.digtvalue1 = '0';
      this.digtvalue2 = '1';
      this.digtvalue3 = '2';
      this.digtvalue4 = '3';
      this.digtvalue5 = '4';
      this.digtvalue6 = 'Tx';

      this.dignhed = 'N';
      this.heddin_dign = false;
      this.heddin_dignhed = false;

      this.dignvalue1 = '0';
      this.dignvalue2 = '1';
      this.dignvalue3 = 'Nx';

      this.digmhed = 'M';
      this.heddin_digm = false;
      this.heddin_digmhed = false;

      this.digmvalue1 = '0';
      this.digmvalue2 = '1';
      this.digmvalue3 = 'Mx';
 
    }



    //////////**************************************************//////
    //////////**************************************************//////

  }
  new_Cancer(){
    //debugger;
    this.tissue = '' ;
    this.histology = '' ;
    this.grade = '' ;
    this.er = '' ;
    this.pdl1 = '' ;
    this.msi = '' ;
    this.egfr = '' ;
    this.alk = '' ;
    this.her2 = '' ;
    this.kras = '' ;
    this.braf = '' ;
    this.hrd = '' ;
    this.brca1 = '' ;
    this.brca2 = '' ;
    this.gscore = '' ;
    this.nfeature = '' ;
    this.pr = '' ;
    this.her2ihs = '' ;
    this.her2fish = '' ;
    this.ki67 = 0 ;
    this.hpv = '' ;
    this.digsite = '' ;
    this.digstage = '' ;
    this.digt = '' ;
    this.dign = '' ;
    this.digm = '' ;
    this.dignotes = '' ;

  this.heddin_tissue = true ;
  this.heddin_histology = true ;
  this.heddin_grade = true ;
  this.heddin_er = true ;
  this.heddin_pdl1 = true ;
  this.heddin_msi = true ;
  this.heddin_egfr = true ;
  this.heddin_alk = true ;
  this.heddin_her2 = true ;
  this.heddin_kras = true ;
  this.heddin_braf = true ;
  this.heddin_hrd = true ;
  this.heddin_brca1 = true ;
  this.heddin_brca2 =    true ;
  this.heddin_gscore =   true ;
  this.heddin_nfeature = true ;

  this.heddin_pr =       true ;
  this.heddin_her2ihs = true;
  this.heddin_her2fish = true ;
  this.heddin_ki67 = true ;
  this.heddin_hpv = true ;
  this.heddin_digsite = true ;
  this.heddin_digstage = true ;
  this.heddin_digt = true ;
  this.heddin_dign = true ;
  this.heddin_digm = true ;
  this.heddin_dignotes = true ;
  this.heddin_Non12Cancer = true;


this.heddin_tissuehed = true;
this.heddin_histologyhed = true;
this.heddin_gradehed = true;
this.heddin_erhed = true;
this.heddin_pdl1hed = true;
this.heddin_msihed =  true;
this.heddin_egfrhed = true;
this.heddin_alkhed =  true;
this.heddin_her2hed = true;
this.heddin_krashed = true;
this.heddin_brafhed = true;
this.heddin_hrdhed =  true;
this.heddin_brca1hed= true;
this.heddin_brca2hed= true;
this.heddin_gscorehed = true;
this.heddin_nfeaturehed = true;
this.heddin_prhed = true;
this.heddin_her2ihshed = true;
this.heddin_her2fishhed = true;
this.heddin_ki67hed = true;
this.heddin_hpvhed = true;
this.heddin_digsitehed = true;
this.heddin_digstagehed = true;
this.heddin_digthed = true;
this.heddin_dignhed = true;
this.heddin_digmhed = true;

this.heddin_tissuetext = true;
 

      this.valuegrad1="Grade I";
      this.valuegrad2="Grade II";
      this.valuegrad3="Grade III";
      this.valuegrad4="NK";

  }
}
